import React, { useState } from "react";
import {
  Container,
  Grid,
  Box,
  Card,
  CardHeader,
  CardContent,
  TextField,
  Button,
  Snackbar,
  Dialog,
  DialogContent,
  CircularProgress,
  Select,
  MenuItem,
} from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import useChangeCourseRequest from "./hooks/useChangeCourseRequest";
import CcpAdminBreadCrumbs from "../../Layout/CcpAdminBreadCrumbs";
import { faBarChart } from "@fortawesome/free-solid-svg-icons";

const CcpAdminChangeCourseRequest = () => {
  const [formData, setFormData] = useState({
    sectionName: "",
    startDate: "",
    changeAction: "",
    endDate: "",
    modality: "",
    instructorType: "",
    instructorName: "",
    startTime: "",
    endTime: "",
    daysOfWeek: "",
    schoolName: "",
    fromName: "",
    schoolId: "1",
  });
  const pageName = "Change Course Request";
  const icon = faBarChart;

  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [loadingDialogOpen, setLoadingDialogOpen] = useState(false);
  const { postData } = useChangeCourseRequest();

  const handleSnackbarClose = () => {
    setSnackbarOpen(false);
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoadingDialogOpen(true);
    try {
      await postData(formData);
      setSnackbarOpen(true);
      setFormData({
        sectionName: "",
        changeAction: "",
        startDate: "",
        endDate: "",
        modality: "",
        instructorType: "",
        instructorName: "",
        startTime: "",
        endTime: "",
        daysOfWeek: "",
        schoolName: "",
        fromName: "",
        schoolId: "1",
      });
    } catch (error) {
      console.error("Error submitting data:", error);
    } finally {
      setLoadingDialogOpen(false);
    }
  };

  return (
    <Container sx={{ marginTop: "100px" }}>
      <CcpAdminBreadCrumbs pageName={pageName} icon={icon} />
      <Box sx={{ flexGrow: 1, marginTop: "10px" }}>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Card>
              <CardHeader
                title="Change Course Request"
                avatar={<EditIcon />}
                sx={{ bgcolor: "#AC1A2F", color: "white" }}
              />
              <CardContent>
                <form onSubmit={handleSubmit}>
                  <Grid container spacing={2}>
                    <Grid item xs={6}>
                      <TextField
                        label="Course and Section #"
                        name="sectionName"
                        value={formData.sectionName}
                        onChange={handleInputChange}
                        fullWidth
                      />
                    </Grid>
                    <Grid item xs={6}>
                      <TextField
                        label="Start Date"
                        type="date"
                        name="startDate"
                        value={formData.startDate}
                        onChange={handleInputChange}
                        InputLabelProps={{ shrink: true }}
                        fullWidth
                      />
                    </Grid>
                    <Grid item xs={6}>
                      <TextField
                        label="End Date"
                        type="date"
                        name="endDate"
                        value={formData.endDate}
                        onChange={handleInputChange}
                        InputLabelProps={{ shrink: true }}
                        fullWidth
                      />
                    </Grid>
                    <Grid item xs={6}>
                      <Select
                        label="Change Action"
                        name="changeAction"
                        value={formData.changeAction}
                        onChange={handleInputChange}
                        fullWidth
                        displayEmpty
                      >
                        <MenuItem value="">
                          <em>Select Action</em>
                        </MenuItem>
                        <MenuItem value="cancel">Cancel</MenuItem>
                        <MenuItem value="change">Change</MenuItem>
                      </Select>
                    </Grid>
                    <Grid item xs={6}>
                      <Select
                        label="Modality"
                        name="modality"
                        value={formData.modality}
                        onChange={handleInputChange}
                        fullWidth
                        displayEmpty
                      >
                        <MenuItem value="">
                          <em>Select Modality</em>
                        </MenuItem>
                        <MenuItem value="face to face">Face to Face</MenuItem>
                        <MenuItem value="online">Online</MenuItem>
                        <MenuItem value="remote">Remote</MenuItem>
                      </Select>
                    </Grid>
                    <Grid item xs={6}>
                      <Select
                        label="Instructor Type"
                        name="instructorType"
                        value={formData.instructorType}
                        onChange={handleInputChange}
                        fullWidth
                        displayEmpty
                      >
                        <MenuItem value="">
                          <em>Select Instructor Type</em>
                        </MenuItem>
                        <MenuItem value="Sinclair">Sinclair</MenuItem>
                        <MenuItem value="High School">High School</MenuItem>
                      </Select>
                    </Grid>
                    <Grid item xs={6}>
                      <TextField
                        label="Instructor Name"
                        name="instructorName"
                        value={formData.instructorName}
                        onChange={handleInputChange}
                        fullWidth
                      />
                    </Grid>
                    <Grid item xs={6}>
                      <TextField
                        label="Start Time"
                        type="time"
                        name="startTime"
                        value={formData.startTime}
                        onChange={handleInputChange}
                        InputLabelProps={{ shrink: true }}
                        fullWidth
                      />
                    </Grid>
                    <Grid item xs={6}>
                      <TextField
                        label="End Time"
                        type="time"
                        name="endTime"
                        value={formData.endTime}
                        onChange={handleInputChange}
                        InputLabelProps={{ shrink: true }}
                        fullWidth
                      />
                    </Grid>
                    <Grid item xs={6}>
                      <TextField
                        label="Days of Week"
                        name="daysOfWeek"
                        value={formData.daysOfWeek}
                        onChange={handleInputChange}
                        fullWidth
                      />
                    </Grid>
                    <Grid item xs={6}>
                      <TextField
                        label="School Name"
                        name="schoolName"
                        value={formData.schoolName}
                        onChange={handleInputChange}
                        fullWidth
                      />
                    </Grid>
                    <Grid item xs={12}>
                      <TextField
                        label="From Name"
                        name="fromName"
                        value={formData.fromName}
                        onChange={handleInputChange}
                        fullWidth
                      />
                    </Grid>
                    <Grid item xs={12}>
                      <Button
                        type="submit"
                        variant="contained"
                        sx={{ bgcolor: "green", color: "white" }}
                        fullWidth
                      >
                        Submit
                      </Button>
                    </Grid>
                  </Grid>
                </form>
              </CardContent>
              <Snackbar
                open={snackbarOpen}
                autoHideDuration={6000}
                onClose={handleSnackbarClose}
                message="Request has been submitted"
                anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
                ContentProps={{
                  sx: { bgcolor: "green", color: "white" },
                }}
              />
              <Dialog open={loadingDialogOpen}>
                <DialogContent>
                  <CircularProgress />
                </DialogContent>
              </Dialog>
            </Card>
          </Grid>
        </Grid>
      </Box>
    </Container>
  );
};

export default CcpAdminChangeCourseRequest;
